import { resolveTaskStatus } from '../helpers';

/** Local calendar day (YYYY-MM-DD) — must match week grid lookups in charts. */
export function toLocalDateKey(value) {
    if (!value) return null;
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) return null;
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}

function pickLatestTimestamp(...values) {
    let best = null;
    let bestTime = -Infinity;
    values.forEach((value) => {
        if (!value) return;
        const time = new Date(value).getTime();
        if (Number.isFinite(time) && time > bestTime) {
            bestTime = time;
            best = value;
        }
    });
    return best;
}

/** Best timestamp for when payout was released (for sorting / display). */
export function getTaskPayoutTimestamp(task) {
    if (!task) return null;

    const payment = task.payment || {};
    const paymentStatus = String(payment.status || '').toLowerCase();
    const status = resolveTaskStatus(task);
    const isPaidOut =
        paymentStatus === 'released' ||
        status === 'released' ||
        status === 'approved';

    if (!isPaidOut) return null;

    const paymentReleased = payment.releasedAt || payment.released_at || null;
    const taskUpdated = task.updatedAt || task.updated_at || null;
    const paymentUpdated = payment.updatedAt || payment.updated_at || null;
    const hasReleaseTx = Boolean(payment.releaseTxHash || payment.release_tx_hash);

    if (paymentReleased) return paymentReleased;

    // Task is updated on approve/complete — more reliable than payment.updatedAt
    // which may still reflect escrow funding time on older rows.
    if (hasReleaseTx || status === 'approved' || status === 'released') {
        return pickLatestTimestamp(
            taskUpdated,
            paymentUpdated,
            task.createdAt,
            task.created_at,
        );
    }

    return pickLatestTimestamp(
        taskUpdated,
        paymentUpdated,
        task.createdAt,
        task.created_at,
    );
}

/** Local date key for chart bucketing. */
export function getTaskPayoutDateKey(task) {
    return toLocalDateKey(getTaskPayoutTimestamp(task));
}
